// extracted by mini-css-extract-plugin
export default {"page":"page__YX373C","main":"main__Pd5xXj"};